import {Component, OnDestroy, OnInit} from '@angular/core';
import {ComponentItem} from '@Common/home/navbar/dynamic-core-components/component-item';
import {MenuNavComponent} from '@Common/home/navbar/components/menu-nav.component';
import {Subscription} from 'rxjs';
import {SubSink} from '@Common/core/utils/subsink';
import {SnackBarToastyService} from '@Common/widgets/general/snack-bar';
import {Menu} from '@Common/home/models/menu.model';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {roles} from './common/enum/roles';
import {switchMap} from 'rxjs/operators';
import {ResponseAvisService} from 'app/demat/common/services/avis/response-avis.service';


@Component({
  selector: 'app-demat-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Dématérialisation de procédures simplifiée';
  menu = [];
  showLoader = false;
  subSink = new SubSink();
  individu: Individu;

  constructor(private pubSubSvc: PubSubService,
              private individuService: IndividuService,
              private opinionsvc: ResponseAvisService) {
  }

  ngOnInit(): void {
    this.subSink.sink = this.individuService.individu$.pipe(
      switchMap(
        (individu) => {
          this.individu = individu;
          return this.opinionsvc.opinionRequested();
        }
      )
    ).subscribe(
      (opinionRequested) => {
        console.log('AppComponent: ', opinionRequested);
        this.fetchMenu(this.individu, opinionRequested)
      }
    )
    this.subSink.sink = this.pubSubSvc.on('loading').subscribe((val) => setTimeout(() => this.showLoader = val));
  }

  fetchMenu(individu: Individu, opinionRequested: boolean) {
    this.menu = [];
    this.menu.push(<Menu>{url: '/demandeur', titre: 'Mes Demandes', nav: false, icon: 'list'});
    if (opinionRequested) {
      this.menu.push(<Menu>{url: '/opinions', titre: 'Mes Avis', nav: false, icon: 'feedback'});
    }
    if (this.individuService.hasRole(individu, roles.gestionnaire) ||
        this.individuService.hasRole(individu, roles.superviseur) ||
        this.individuService.hasRole(individu, roles.admin)) {
      this.menu.push(<Menu>{url: '/gestion/demandes', titre: 'Gestion des Demandes', nav: false, icon: 'assignment'});
    }
    if (this.individuService.hasRole(individu, roles.superviseur) ||
        this.individuService.hasRole(individu, roles.admin)) {
      this.menu.push(<Menu>{url: '/gestion', titre: 'Gestion des Formulaires', nav: false, icon: 'topic'});
    }
    if (this.individuService.hasRole(individu, roles.admin)) {
      this.menu.push({url: '/admin', titre: 'Admin', nav: false, icon: 'settings'});
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  getComponents() {
    return [
      new ComponentItem(MenuNavComponent, this.menu)
    ];
  }

}
